import { RectSize } from '../../../common/maths/geometry/rect/rectTypes';
import { Point } from '../../../common/maths/geometry/pointTypes';

// Rule for whether to maintain aspect ratio when resizing
export enum MaintainAspectRatioMode {
    ALWAYS = 'always',
    OPTIONAL = 'optional', // e.g. hold command to change aspect ratio
    NEVER = 'never',
}

// Rule for what kind of aspect ratio to maintain, if any
export enum ResizeAspectLock {
    ELEMENT = 'element',
    MEDIA = 'media',
    NONE = 'none',
}

// Temp value during resize
export enum MediaElementContentVisibility {
    SHOW_ALL = 'showAll',
    SHOW_MEDIA_ONLY = 'showMediaOnly',
    UNSET = 'unset',
}

// Actual value saved to element content
export enum MediaOnlyDisplay {
    SHOW_ALL = 'showAll',
    TOO_SMALL = 'mediaOnly-tooSmall', // Media only display triggered by a resize being too small
    PREFERENCE = 'mediaOnly-preference', // Media only display triggered by user toggling toolbar tool
}

export type ResizeChanges = Partial<{
    width: number;
    height: number;
    minHeight: number | null;
    maxHeight: number | null;
    autoHeight: boolean;
    media: RectSize;
    drawing: RectSize;
    mediaOnlyDisplay: MediaOnlyDisplay;
}> | null;

export type SetElementSizeAndPosition = (changes: ResizeChanges, position?: Point) => void;
export type SetTempElementSize = (size: RectSize | null) => void;
